const batchService = async (locale, childItemNumbers, distributionCenters, selectedWarehouse = "", serviceConfig) => {
  const {
    endpoint = "",
    method = "POST",
    required_request_headers,
    // retryconfig,
    connection_timeout,
    timeout
  } = serviceConfig;
  const SITE = locale === "en-us" ? "USBC" : "CABC";
  const { client_identifier, content_type } = required_request_headers || {};
  const clientId = client_identifier[String(SITE).toLowerCase()] || "";
  const { env = "", service = "" } = required_request_headers.costco;
  const requestQueryParams = {
    distributionCenters,
    itemNumbers: childItemNumbers,
    selectedWarehouse
  };
  const options = {
    body: JSON.stringify(requestQueryParams),
    headers: {
      "client-identifier": clientId,
      "content-type": content_type,
      "costco.env": env,
      "costco.service": service
    },
    method,
    signal: connection_timeout ? AbortSignal.timeout(connection_timeout) : null,
    timeout
  };
  try {
    const res = await fetch(endpoint, options);
    const { status, statusText } = res;
    const batchInfo = await res.json();
    if (!res.ok) {
      console.error(
        `PDPBI Child Ids: ${childItemNumbers} Status: ${status} Status Text: ${statusText} Response: - ${JSON.stringify(batchInfo)}`
      );
    } else if (process.env.NODE_ENV === "development") {
      console.info(
        `PDPBI Child Ids: ${childItemNumbers} Status: ${status} Status Text: ${statusText} Response: - ${JSON.stringify(batchInfo)}`
      );
    }
    return { batchInfo, status };
  } catch (error) {
    console.error(
      `PDPBI Child Ids: ${childItemNumbers} failed with PBI Error: ${error}`
    );
    throw error;
  }
};
export {
  batchService
};
